import { Box } from '@givebutter/primitives/box';
import { PendingUsers } from './PendingUsers';
import { AccountMembers } from 'assets/js/pages/account-settings/users/AccountMembers';
import { InviteUserSettings } from 'assets/js/pages/account-settings/users/InviteUserSettings';

const UserSettings = () => (
    <div className="flex flex-col gap-4">
        <Box className="flex flex-col gap-4 p-8">
            <InviteUserSettings />
            <AccountMembers />
        </Box>
        <Box className="flex flex-col gap-4 p-8">
            <div className="flex flex-col gap-4">
                <p className="m-0 text-xl font-medium text-black">Pending Invitations</p>
                <p className="text-md max-w-sm text-gray-600">
                    Invites you've sent that haven't yet been accepted. To resend an invite, just
                    enter the email above again.
                </p>
            </div>
            <PendingUsers />
        </Box>
    </div>
);

export { UserSettings };
